import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, DatePicker, Button, message, Typography, Col, Row } from 'antd';
import axios from '../../../utils/BasicAuthAPI';
import SearchAudit from "./SearchAudit";
import moment from "moment";


const { Text, Link } = Typography;

const SearchAuditModal = (props) => {
    const [visible, setVisible] = useState(false);

    const sendBackData = (data, searchData) => {
        setVisible(false);
        props.modelCloseHandler(data, searchData, true);
    }


    const handleCancel = () => {
        setVisible(false);
        props.modelCloseHandler([], props.searchtData, false);
    };

    useEffect(() => {
        if (props.visible) {
            setVisible(props.visible)
        }
    }, [props]);
    return (
        <React.Fragment>

            <Modal
                title={"Search"}
                open={visible}
                onOk={handleCancel}
                onCancel={handleCancel}
                className={"ThemeModal"}
            // width={960}
            >
                <SearchAudit
                    sendBackData={sendBackData}
                    defaultValues={props.searchtData}
                    AuditLines={props.AuditLines}
                    AuditType={props.AuditType}
                    AuditUsers={props.AuditUsers}
                />


            </Modal>
        </React.Fragment>

    );
};

export default SearchAuditModal;